/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import { getDay } from '../../utils/date';
import Filters from '../Filters';
import { isEmpty } from '../../utils/lodashExtend';
import { getTaskByPost, getTaskList } from '../../apis/tasks';
import { getParams } from '../../utils/params';
import { ControlTable } from '../Table';
import { taskListFields } from '../../utils/task';
import { getTaskService } from '../../services/task';
import { viewLoading } from '../../utils/loading';

const TaskSelectedList = ({ cancel, task, useFormItem, setTaskData }) => {
  const [filters] = useState([
    {
      title: "조회기간",
      type: "CustomDatePicker",
      key: "range.createdTime",
    },
    {
      title: "제목 검색",
      key: "search.title",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ]);


  const {
    form,
    setSubmit,
    handleOnChange,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    search: {
      title: ''
    },
    range: {
      createdTime: [
        getDay(7), getDay()
      ]
    },
    approvalTargetType: task.type || '',
    limit: 10,
    offset: 0,
  });

  const _submit = (params) => {
    getTaskList({
      ...getParams(params),
      ownership: 'requester'
    })
      .then((res) => {
        setTotal(res.data.totalCount);
        setList(res.data.approvalTargetList || []);
      })
      .catch((err) => {

      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!isEmpty(task)) {
      _submit(form);
      setSubmit(_submit);
    }
  }, [task]);

  const openTaskDetail = async (data, e) => {
    viewLoading("할일 정보 불러오는 중입니다.");

    getTaskByPost({
      postIdx: data.postIdx,
      postType: data.postType,
    }).then(async (res) => {
      const _task = await getTaskService({
        defaultData: res.data,
        mode: "create",
        type: task.type
      });

      !isEmpty(useFormItem) &&
        !isEmpty(_task.defaultForm) &&
        useFormItem.setForm(
          _task.defaultForm
        );
      cancel();

      setTimeout(() => {
        viewLoading(false);
      }, 500);
    }).catch(() => viewLoading(false));


  };


  return (
    <>

      <Filters
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isControl={false}
        isLoading={isLoading}
        fields={taskListFields}
        list={list}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        onSelect={openTaskDetail}
      />
    </>
  );
};

export default TaskSelectedList;